module.exports = __webpack_public_path__ + "img/医药WCA_01.d9e58032.webp";